export default __webpack_public_path__ + "static/media/no-sign-replacement.5cddb8f2.jpg";